import { Component } from 'react';
import { Button, ListGroupItem } from 'react-bootstrap';
import { ButtonVo } from '../blogData/ButtonVo';
import { TextSaveVo } from '../blogData/TextSaveVo';
import DetailBox from '../classes/DetailBox';
import MainController from '../classes/MainController';
import { MainStorage } from '../classes/MainStorage';
import ButtonLine from '../ui/ButtonLine';
import { DataCenter } from '../util/DataCenter';
import { MainUtil } from '../util/MainUtil';
interface MyProps { }
interface MyState { filterType: string, texts: TextSaveVo[], page: number, selectedText: TextSaveVo | null,searchText:string }
class SavesScreen extends Component<MyProps, MyState>
{
    private ms: MainStorage = MainStorage.getInstance();
    private mc:MainController=MainController.getInstance();

    private filterID: number = 0;
    private catChanged: boolean = false;

    constructor(props: MyProps) {
        super(props);
        this.state = { filterType: "all", texts: [], page: 0, selectedText: null,searchText:"" };
    }
    componentDidMount(): void {
        this.getSaves();
    }
    getButtons() {
        if (this.state.searchText.length > 0) {
            return "";
        }
        //make an array of buttonVo objects based on the categories in mainStorage
        let buttonArray: ButtonVo[] = [];
        buttonArray.push(new ButtonVo("All", "light", 0));

        for (let i: number = 1; i < this.ms.cats.length; i++) {
            let cat: string = this.ms.cats[i].catName;
            let buttonVo: ButtonVo = new ButtonVo(cat, "light", this.ms.cats[i].id);
            buttonArray.push(buttonVo);
        }
        buttonArray.push(new ButtonVo("Favorites", "light", -1));

        return <ButtonLine buttonArray={buttonArray} actionCallback={this.setFilter.bind(this)} selected={this.filterID} />
    }
    setFilter(index: number) {
        console.log("setFilter", index);
        if (index !== this.filterID) {
            this.filterID = index;
            this.catChanged = true;
            this.setState({ page: 0 });
            this.getSaves();

        }
    }
    getSaves() {
        let filterType: string = "bycat";
        let page: number = this.state.page;
        if (this.catChanged === true) {
            page = 0;
        }
        if (this.filterID === 0) {
            filterType = "all";
        }
        if (this.filterID === 7) {
            console.log("fav");
            DataCenter.getFavorites(this.ms.userCode, page, this.gotSaves.bind(this));
            return;
        }
        let catID: number = this.ms.cats[this.filterID].id;

        DataCenter.getSaves(this.ms.userCode, catID, page, filterType, this.gotSaves.bind(this));
    }
    gotSaves(data: any) {
        // console.log(data);
        //map the data to textsavevo objects
        let textArray: TextSaveVo[] = data.map((item: any) => {
            return new TextSaveVo(item.id, item.text, parseInt(item.fav));
        });
        //  console.log(textArray);

        if (this.catChanged === false) {
            let nArray: TextSaveVo[] = this.state.texts.concat(textArray);
            this.setState({ texts: nArray });
        }
        else {
            this.setState({ texts: textArray, page: 0 });
            this.catChanged = false;
        }

    }
    getTextList() {
        if (this.state.texts.length === 0) {

            return "Nothing to show";
        }
        let textCards: JSX.Element[] = [];
        for (let i: number = 0; i < this.state.texts.length; i++) {
            //  console.log(this.state.texts[i]);
            let key: string = "card" + i.toString();
            let text:JSX.Element=(<span>{this.state.texts[i].text}</span>);
            //mark the search text
            if(this.state.searchText.length>0){
                text=MainUtil.getHighlightedText(this.state.texts[i].text,this.state.searchText);
            }
            textCards.push(<ListGroupItem key={key} onClick={() => { this.setState({ selectedText: this.state.texts[i] }) }}>{text}</ListGroupItem>);
        }
        if (this.state.texts.length > 49) {
            textCards.push(<ListGroupItem key="cardMore" onClick={() => { this.setState({ page: this.state.page + 1 }, () => { this.getSaves() }) }}><Button>Load More</Button></ListGroupItem>);
        }
        return textCards;
    }
    getDetailBox() {
        if (this.state.selectedText === null) {
            return "";
        }
        return <DetailBox textSaveVo={this.state.selectedText} callback={this.detailBoxCallback.bind(this)} />
    }
    detailBoxCallback(action: string) {
        console.log(action);
        switch (action) {
            case "copy":
                if (this.state.selectedText !== null) {
                    MainUtil.doCopy(this.state.selectedText.text);
                }
                break;
            case "download":
                if (this.state.selectedText !== null) {
                    MainUtil.downloadText(this.state.selectedText.text, this.state.selectedText.text);;
                }
                break;
            case "close":
                this.setState({ selectedText: null });
                break;
            case "delete":
                if (this.state.selectedText !== null) {
                    DataCenter.deleteSave( this.state.selectedText.id, this.deleteSaveCallback.bind(this));
                }
                //console.log("delete " + this.state.selectedText?.id.toString());
                //this.setState({ selectedText: null });
                //  this.getSaves();
                break;
            case "fav":
                if (this.state.selectedText !== null) {
                    DataCenter.markAsFavorite(this.ms.userCode, this.state.selectedText?.id, this.favoriteAdded.bind(this));
                }
                break;
            case "unfav":
                if (this.state.selectedText !== null) {
                    DataCenter.removeFavorite(this.ms.userCode, this.state.selectedText?.id, this.favoriteRemoved.bind(this));
                }
                break;
            default:
                break;
        }
    };
    
    favoriteAdded()
    {
        this.mc.showFlashMessage("Favorite added");
        let currentText:TextSaveVo | null=this.state.selectedText;
        if(currentText!==null)
        {
            currentText.fav=1;
            this.setState({selectedText:currentText});
        }
        if (this.filterID === 7) {
            this.catChanged = true;
        }
        this.getSaves();
    }
    favoriteRemoved()
    {
        this.mc.showFlashMessage("Favorite removed");
        let currentText:TextSaveVo | null=this.state.selectedText;
        if(currentText!==null)
        {
            currentText.fav=0;
            this.setState({selectedText:currentText});
        }
        if (this.filterID === 7) {
            this.catChanged = true;
        }
        this.getSaves();
    }
    deleteSaveCallback()
    {
        this.mc.showFlashMessage("Text deleted");
        this.setState({ selectedText: null });
        this.catChanged = true;
        this.getSaves();

    }
    searchTextChange(event: any) {
        this.setState({ searchText: event.target.value });
        if (event.target.value.length > 2) {
            this.catChanged = true;
            DataCenter.searchSaves(this.ms.userCode, event.target.value, this.gotSaves.bind(this));
        }
    }
    render() {
        //search box

        return (<div>

            <div className='bline'>{this.getButtons()}</div>
            <div className='tac'><input onChange={this.searchTextChange.bind(this)} type="text" className='search-box' placeholder="Search" value={this.state.searchText} /></div>
            <hr />
            <div className='textsave-scroll'>{this.getTextList()}</div>
            {this.getDetailBox()}
        </div>)
    }
}
export default SavesScreen;